import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  leading?: ReactNode;
  trailing?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ label, hint, error, leading, trailing, className, ...rest }, ref) => (
    <label className="block">
      {label && (
        <span className="block mb-1.5 text-xs font-semibold uppercase tracking-wider text-fg-muted">
          {label}
        </span>
      )}
      <span
        className={cn(
          'flex items-stretch rounded-xl bg-surface-2 border overflow-hidden',
          error ? 'border-danger' : 'border-border focus-within:border-accent',
        )}
      >
        {leading && <span className="flex items-center pl-3 text-fg-muted">{leading}</span>}
        <input
          ref={ref}
          {...rest}
          className={cn(
            'flex-1 bg-transparent px-3 h-11 text-sm placeholder:text-fg-subtle focus:outline-none',
            className,
          )}
        />
        {trailing && <span className="flex items-center pr-3 text-fg-muted">{trailing}</span>}
      </span>
      {error ? (
        <span className="block mt-1.5 text-xs text-danger">{error}</span>
      ) : hint ? (
        <span className="block mt-1.5 text-xs text-fg-muted">{hint}</span>
      ) : null}
    </label>
  ),
);
Input.displayName = 'Input';
